import React from 'react';
import PictureImg from '../PictureImg';

const brandLogos = [
  { base: "/api/img/brand-le-dolci-sorelle", alt: "Le Dolci Sorelle" },
  { base: "/api/img/brand-san-chimento", alt: "San Chimento" },
  { base: "/api/img/brand-salumi-de-nobili", alt: "Salumi De' Nobili" },
  { base: "/api/img/brand-san-marziale", alt: "San Marziale" },
  { base: "/api/img/brand-pausa-italiana", alt: "Pausa Italiana" },
  { base: "/api/img/brand-italiana-formaggi", alt: "Italiana Formaggi" },
  { base: "/api/img/brand-antica-latteria", alt: "Antica Latteria" },
];

const BrandsSection = () => {
  // Double the logos array for seamless infinite scroll
  const doubledLogos = [...brandLogos, ...brandLogos];
  
  return (
    <section id="partners" className="py-20 px-6 bg-white">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="text-blue-900 font-semibold tracking-wide uppercase text-sm">
            Our Partners
          </span>
          <h2 className="md:text-5xl !font-bold !text-4xl mt-3 text-stone-900">
            Italian producers and brands we represent
          </h2>
        </div>
        <div className="marquee-container">
          <div className="marquee-content">
            {doubledLogos.map((logo, index) => (
              <PictureImg
                key={`logo-${index}`}
                base={logo.base}
                alt={logo.alt}
                className="h-32 max-w-[200px] object-contain transition-all duration-300 flex-shrink-0 mx-8"
                width={200}
                height={128}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
